
//   mainColor: '#014d4e',


export const colors = {
  white: '#FFFFFF',
  mainColor: '#111111',
  lighGreenColor: "#3ee4a9",
  primaryColor: '#014d4e',
  accentColor: '#00b497',
  bodyTextColor: '#333333',
  imageBackground: '#F6F8FB',
  transparent: 'transparent',
  secondaryTextColor: '#00b497',
  darkTextColor: '#000000',
};

export const theme = { colors };

// export const colors = {
//   white: '#FFFFFF',
//   mainColor: '#111111',
//   accentColor: '#7065F0',
//   bodyTextColor: '#333333',
//   imageBackground: '#F6F8FB',
//   transparent: 'transparent',
//   secondaryTextColor: '#7065F0',
//   darkTextColor: '#000000',
// };

// export const theme = { colors };
